import type { Option } from "../constants";
import type { ResourceCategoryV2 } from "../fields/form-entity-select";
import {
	resolveScreenFieldDisplayLabel,
	type ScreenFieldRef,
} from "./data-field-type-utils";

/**
 * Human-readable screen field label for display / editor insert.
 * Same-location fields keep their label (plain or `Table.Field`).
 * Cross-location fields show `LocationName.fieldName`.
 */
export function formatScreenFieldDisplayLabel(
	label: string,
	fieldId: string | undefined,
	currentScreenFieldIds: ReadonlySet<string>,
	options?: {
		screenFieldRef?: ScreenFieldRef;
		ruleLocationName?: string;
		locationName?: string;
	},
): string {
	return resolveScreenFieldDisplayLabel(label, fieldId, currentScreenFieldIds, options);
}

/**
 * Label inserted into formula/reaction editors.
 */
export function getEditorInsertLabelForPickedResource(
	category: ResourceCategoryV2,
	label: string,
	value: string,
	currentScreenFields: Option[],
	_advancedTriggers: Option[] = [],
	locationName?: string,
	ruleLocationName?: string,
): string {
	if (category === "advancedTrigger") {
		return label;
	}
	if (category !== "screenField") {
		return label;
	}
	const currentScreenFieldIds = new Set(currentScreenFields.map((field) => field.value));
	return formatScreenFieldDisplayLabel(label, value, currentScreenFieldIds, {
		locationName,
		ruleLocationName,
	});
}
